module.exports = __webpack_public_path__ + "static/img/cliptopia.9c5705e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects/cliptopia.png
// module id = 6k2E
// module chunks = 0